import { Pipe, PipeTransform } from '@angular/core';
import { Trainer } from '../../_services';

@Pipe({ name: 'filterByAgency' })
export class TrainersAgencyPipe implements PipeTransform {
    transform(
        trainers: any[],
        agencyFilter: string,
        active: boolean,
        filterMetadata?: any,
        filterLabel?: string
    ): any[] {
        let filteredTrainers = trainers.filter(
            (trainer) =>
                agencyFilter === 'Toutes les agences' ||
                trainer.companyName.toLowerCase() === agencyFilter.toLowerCase()
        );
        switch (filterLabel) {
            case 'name': {
                filterMetadata.countName = filteredTrainers.length;
                break;
            }
            case 'can': {
                filterMetadata.countCan = filteredTrainers.length;
                break;
            }
            case 'given': {
                filterMetadata.countGiven = filteredTrainers.length;
                break;
            }
            case 'wished': {
                filterMetadata.countWished = filteredTrainers.length;
                break;
            }
            case 'followed': {
                filterMetadata.countFollowed = filteredTrainers.length;
                break;
            }
            case 'refuse': {
                filterMetadata.countRefuse = filteredTrainers.length;
                break;
            }
            default: {
                break;
            }
        }
        return filteredTrainers;
    }
}

@Pipe({ name: 'cleanAgencyName' })
export class TrainersAgencyNamePipe implements PipeTransform {
    transform(agency: string) {
        return agency.split(' ')[1];
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainers-agency.pipe.ts